// Shared config + loader for Teuteuf's externally-hosted "Passport" web
// components (ads-removal offer + payment return status). These aren't
// published as an npm package yet — same as the login page before it was
// packaged as @teuteuf-games/login-page — so we load them as plain <script>
// tags and mount the custom elements imperatively from the routes that need
// them.
//
// Keep these URLs in sync with the <link rel="preload"> entries in
// src/app/layout.tsx.

export const PASSPORT_OFFER_SCRIPT_URL =
  'https://teuteuf-web-components.pages.dev/teuteuf-passport-offer.js';
export const PAYMENT_RETURN_SCRIPT_URL =
  'https://teuteuf-web-components.pages.dev/teuteuf-payment-return.js';

const PASSPORT_OFFER_SCRIPT_MARKER = 'data-teuteuf-passport-offer';
const PAYMENT_RETURN_SCRIPT_MARKER = 'data-teuteuf-payment-return';

function loadScriptOnce(src: string, marker: string): void {
  if (typeof document === 'undefined') return;
  if (document.querySelector(`script[${marker}]`)) return;

  const script = document.createElement('script');
  script.src = src;
  script.crossOrigin = 'anonymous';
  script.async = true;
  script.setAttribute(marker, '');
  document.body.appendChild(script);
}

export function loadPassportOfferScript(): void {
  loadScriptOnce(PASSPORT_OFFER_SCRIPT_URL, PASSPORT_OFFER_SCRIPT_MARKER);
}

export function loadPaymentReturnScript(): void {
  loadScriptOnce(PAYMENT_RETURN_SCRIPT_URL, PAYMENT_RETURN_SCRIPT_MARKER);
}
